import {all, call, delay, put, putResolve, takeLatest} from '@redux-saga/core/effects';
import {getArticlePage, getArticlesByPage} from 'api/articles/articles';
import {deleteToken, setToken} from 'api/auth/auth';
import {getMorePoints, getPointsHistory} from 'api/gifts/gifts';
import {getPost} from 'api/homepage/homepage';
import {
  getCircleRecipeList,
  getConseilsByPage,
  getRecipes,
  getRecipesByCategoryAndPage,
} from 'api/recipes/recipes';
import {callSagaIfHasToken} from 'lib/sagas';

const requestInterval = 300;

function* preFetchPostSaga(id, type) {
  yield put(getPost({id, type}));
}

function* preFetchArticlesPageSaga() {
  const {data: getArticlePageData} = yield putResolve(getArticlePage());
  const dossiersSlider = getArticlePageData?.acf?.dossiers_slider || [];
  yield all(
    dossiersSlider.map(slide =>
      call(preFetchPostSaga, slide.dossiers_slider_image_mobile || slide.dossiers_slider_image, 'media'),
    ),
  );
  yield put(getArticlesByPage({page: 1}));
}

function* preFetchRecipesPageSaga() {
  const {data: getRecipesData} = yield putResolve(getRecipes());
  const recettesSlider = getRecipesData?.acf?.recettes_slider || [];
  yield all(
    recettesSlider.map(slide =>
      call(preFetchPostSaga, slide.recettes_slider_image_mobile || slide.recettes_slider_image, 'media'),
    ),
  );
  yield put(getRecipesByCategoryAndPage({page: 1, category: null}));
  yield put(getCircleRecipeList());
  yield put(getConseilsByPage({page: 1}));
}

function* preFetchGiftsPageSaga() {
  yield put(getMorePoints());
  yield put(getPointsHistory());
}

function* preFetchContentSaga() {
  yield delay(2 * requestInterval);
  yield call(preFetchArticlesPageSaga);
  yield delay(requestInterval);
  yield call(preFetchRecipesPageSaga);
  yield delay(requestInterval);
  yield call(preFetchGiftsPageSaga);
}

export function* saga() {
  yield takeLatest(
    ['persist/REHYDRATE', setToken.toString(), deleteToken.toString()],
    callSagaIfHasToken,
    preFetchContentSaga,
  );
}
